/**
 * Not sure why this is needed, moved to a separate file to DRY up code
 */

const encoderReservedCharacters = ['!', "'", '(', ')', '*', '[', ']', '@', '£', '$'];
const encoderReservedEncoder = c => '%' + c.charCodeAt(0).toString(16);
const encoderReservedEncoded = encoderReservedCharacters.map(encoderReservedEncoder);
const encoderReservedRegex = new RegExp(encoderReservedEncoded.join('|'), 'g');
const encoderReservedDecoder = c => String.fromCharCode(parseInt(c.substr(1), 16));

const encode = (segment) => encodeURIComponent(segment)
    .replace(encoderReservedRegex, encoderReservedDecoder)
    .replace(/(%5B)+/g, '[')
    .replace(/(%5D)+/g, ']')
    .replace(/(%20)+/g, '+')
    .replace(/(%2B)+/g, '+')
    .replace(/%2C/g, ',')
    .replace(/%2F/g, '/');

export function stringifyQuery(query) {
    const res = query ? Object.keys(query).map(key => {
        const val = query[key];

        if (val === undefined) {
            return '';
        }

        if (val === null) {
            return encode(key);
        }

        if (Array.isArray(val)) {
            const result = []

            val.forEach(val2 => {
                if (val2 === undefined) {
                    return;
                }

                if (val2 === null) {
                    result.push(encode(key));
                } else {
                    result.push(encode(key) + '=' + encode(val2));
                }
            })

            return result.join('&');
        }

        return encode(key) + '=' + encode(val);
    }).filter(x => x.length > 0).join('&') : null

    return res ? `?${res}` : ''
}

